import React, { useState } from 'react'
import { AgGridReact } from 'ag-grid-react'; 
import "ag-grid-community/styles/ag-grid.css"; 
import "ag-grid-community/styles/ag-theme-quartz.css"; 
import { useSelector } from 'react-redux'; 

const TableComponentReport = ({report, meters,parameter}) => {
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
    // console.log(report)
    // console.log(meters)

    // console.log(meters)
    const columns = [];
    
      meters.map((i)=>{
            columns.push({headerName: i.title,field:i.dataIndex,width:i.minWidth, flex: 1,valueFormatter: (params) => {
      if (typeof params.value === "string") return params.value;
      return params.value; // keep numbers too
    }})
      })
      // console.log(columns)
  const color = useSelector((state) => state.ThemeChange);
    // console.log(color)
    const roundToTwo = (num) => {
  if (isNaN(num)) return 0; // safety check
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

const getTotals = (data, columns) => {
  // console.log(data)
  // console.log(columns)
  let totals = {};
  columns.forEach(col => {
    const field = col.field;
    // console.log(data[0])
    // Only calculate totals for numeric columns
    if (typeof data[0]?.[field] === "number") {
      totals[field] = data.reduce(
        (sum, row) => sum + (Number(row[field]) || 0),
        0
      );
    }
  });
  return totals;
};

const totalRow = React.useMemo(() => {
  if (!report || report.length === 0) return [];

  const totals = getTotals(report, columns);
  // console.log(totals)

  return [
    {
      // ...totals,
      consumption: roundToTwo(totals.consumption),
      closing: "TOTAL",  //  only first column shows TOTAL
    },
  ];
}, [report, columns]);






// console.log(totalRow)
// console.log(columns)

  return (
    <div
          className={`${isdarkMode ? "ag-theme-quartz-dark": "ag-theme-alpine"}`}
          style={{
            '--ag-header-background-color': color.themeConfig.colorPrimary, 
            '--ag-header-foreground-color': '#fff', 
            height: "80vh", width: "100%", overflowY: "auto" 
          }}
        >
          <AgGridReact
  rowData={[...report ]}
  columnDefs={columns.length > 1 ? columns : []}
   pinnedBottomRowData={totalRow}
  defaultColDef={{
    resizable: true,
  }}
  pagination={true}
  domLayout="normal"
  rowHeight={50}
/>
        </div>
  )
}

export default TableComponentReport